import { render, staticRenderFns } from "./BSSignWorkday.vue?vue&type=template&id=dea281ba"
import script from "./BSSignWorkday.vue?vue&type=script&lang=js"
export * from "./BSSignWorkday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports